import { Box, Form, ModalDialog, SpacerNew, Text } from '@jfs/ui-new'
import { ButtonNew as Button } from '../../components/AdminButton'
import { AdminPortalTextInput } from '../../components/AdminPortalTextInput'
import { Dropdown } from '../../components/Dropdown'
import { MandateAmountTextInput } from './MandateAmountTextInput'

interface AddNewDevicePlanModelProps {
  show: boolean
  onDismiss: () => void
  onPress: (args: any) => void
  errorMessage: string
  isLoading: boolean
  deviceListData: any
  selectedDevice?: string
  deviceType: string
}

export const AddNewDevicePlanModel = ({
  show,
  onDismiss,
  onPress,
  errorMessage,
  isLoading,
  deviceListData,
  selectedDevice,
  deviceType,
}: AddNewDevicePlanModelProps) => {
  const isValid = ({ variantId, recurringFee, oneTimeFee, mandateRuleAmount }) => {
    return (
      (variantId && !+oneTimeFee && !+recurringFee) ||
      (variantId && +oneTimeFee && !+recurringFee) ||
      (variantId && +oneTimeFee && +mandateRuleAmount && +mandateRuleAmount >= Math.max(oneTimeFee, recurringFee))
    )
    //variantId && +recurringFee && +oneTimeFee && +mandateRuleAmount
  }

  return (
    <ModalDialog show={show} onDismiss={onDismiss} type="CenteredWrap" title={'Add new Device Plan'}>
      <Box
        backgroundColor={'WHITE'}
        width={'50vw'}
        p={20}
        pb={60}
        borderBottomLeftRadius={20}
        borderBottomRightRadius={16}>
        <Form
          container={FormContainer}
          formData={AddNewPlanForm({ errorMessage, deviceListData, selectedDevice })}
          actionButtons={(props) => (
            <Button
              {...props}
              title={'Add Plan'}
              type={'primaryFullWidth'}
              height={42}
              isLoading={isLoading}
              onPress={() => onPress(props.values)}
              disabled={!isValid(props.values)}
            />
          )}
          initialValues={{ variantId: selectedDevice, deviceType }}
        />
      </Box>
    </ModalDialog>
  )
}

interface AddNewDeviceFormProps {
  errorMessage: string
  deviceListData: any
  selectedDevice: string
}

export const AddNewPlanForm = ({ errorMessage, deviceListData, selectedDevice }: AddNewDeviceFormProps) => [
  {
    verticalSpacing: 0,
    formItems: [
      {
        fieldName: 'deviceType',
        ComponentName: Dropdown,
        data: [],
        title: 'Device Type',
        label: 'Selected Device Variant',
        selectable: false,
      },
      {
        fieldName: 'spacer1',
        ComponentName: SpacerNew,
        size: 8,
      },
      {
        fieldName: 'variantId',
        ComponentName: Dropdown,
        data: deviceListData,
        title: 'Device Variant',
        label: 'Select Device Variant',
        selectable: !selectedDevice,
      },
      {
        fieldName: 'recurringFee',
        placeholder: 'Enter recurringFee',
        ComponentName: AdminPortalTextInput,
        textType: 'numOnly',
        maxLength: 4,
      },
      {
        fieldName: 'oneTimeFee',
        placeholder: 'Enter one time fee',
        ComponentName: AdminPortalTextInput,
        textType: 'numOnly',
        maxLength: 4,
      },
      {
        fieldName: 'mandateRuleAmount',
        placeholder: 'Enter mandate rule amount',
        ComponentName: MandateAmountTextInput,
        textType: 'numOnly',
        maxLength: 4,
      },

      {
        fieldName: FORM_FIELDS.error,
        ComponentName: Text,
        value: errorMessage,
        color: 'RED',
      },
      {
        fieldName: 'SPACER_1',
        ComponentName: SpacerNew,
        size: 15,
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]

export const FORM_FIELDS = {
  variantName: 'variantName',
  error: 'error',
}

const FormContainer = ({ children }) => <Box width={'100%'}>{children}</Box>
